import { BaseSeriesSpecTransformer } from "../../base";

export class CircularProgressSeriesSpecTransformer extends BaseSeriesSpecTransformer {
    constructor() {
        super(...arguments), this._supportStack = !0;
    }
}
//# sourceMappingURL=circular-transformer.js.map
